const config:{baseURL: string} = {
	baseURL: "https://portal.cleanet.pro/api",
	// baseURL: "http://localhost:3600/api",
}

export default config
